<template>
  <div class="chatbox-container">
    <!-- Header Section (customizable per application) -->
    <div class="header-section">
      <slot name="header">
        <img class="header-icon" src="@/assets/img/logo-cobalt.jpg" alt="" />
      </slot>
    </div>

    <!-- Chat Input Section -->
    <div class="input-section">
      <ChatInput
        :placeholder="inputPlaceholder"
        :send-button-text="sendButtonText"
        @sent="handleMessageSent"
        @error="handleError"
      />
    </div>

    <!-- Chat History Section -->
    <div class="history-section">
      <ChatHistory
        :loading-text="loadingText"
        :bot-avatar="botAvatar"
        :bot-avatar-alt="botAvatarAlt"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ChatInput from './ChatInput.vue';
import ChatHistory from './ChatHistory.vue';

export default {
  name: 'ChatBox',
  components: {
    ChatInput,
    ChatHistory,
  },
  props: {
    // API Configuration
    apiUrl: {
      type: String,
      default: 'https://cobalt-v1-92585043467.southamerica-east1.run.app/chat-consultation',
    },
    // UI Configuration
    inputPlaceholder: {
      type: String,
      default: 'Digite sua dúvida ou mensagem.',
    },
    sendButtonText: {
      type: String,
      default: 'Enviar',
    },
    loadingText: {
      type: String,
      default: 'Aguarde enquanto sua mensagem é processada.',
    },
    botAvatar: {
      type: String,
      default: () => require('@/assets/img/agape.jpg'),
    },
    botAvatarAlt: {
      type: String,
      default: 'Bot avatar',
    },
  },
  mounted() {
    // Set API URL in store if provided as prop
    if (this.apiUrl) {
      this.setApiUrl(this.apiUrl);
    }
  },
  methods: {
    ...mapActions('chat', ['setApiUrl']),
    handleMessageSent() {
      this.$emit('message-sent');
    },
    handleError(error) {
      this.$emit('error', error);
    },
  },
};
</script>

<style scoped>
.chatbox-container {
  position: absolute;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: "Montserrat", Sans-serif;
}

.header-section {
  display: flex;
  justify-content: center;
  padding: 3vh 0;
}

.header-icon {
  height: 10vh;
  margin-right: 0;
  padding-left: 20px;
  padding-right: 20px;
}

.input-section {
  position: absolute;
  top: 18vh;
  left: 5vw;
  width: 90vw;
}

.history-section {
  position: absolute;
  top: 30vh;
  left: 5vw;
  width: 88vw;
  height: 63vh;
  z-index: 1;
}

@media only screen and (max-width: 600px) {
  .header-icon {
    margin-top: 5vh;
    height: 5vh;
  }

  .input-section {
    top: 15vh;
  }

  .history-section {
    top: 25vh;
    height: 67vh;
  }
}
</style>
